import {
    SET_ARTICLES,
    SET_BOOKMARK
} from '../../actions';

const initialState = {
    articles: [],
    bookmark: false
}

function savedArticleReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_ARTICLES:
            newState.articles = action.articles;
            newState.bookmark = state.status;
            return newState;
        
        case SET_BOOKMARK:
            newState.articles = state.articles;
            newState.bookmark = action.status;
            return newState;
        
        default:
            return state;
    }
}

export default savedArticleReducer;
